<template>
    <div class="accordion-header" :aria-labelledby="'heading' + index">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + index" aria-expanded="true" :aria-controls="'collapse' + index">
            <BaseHeading :heading="title" classNames="white m-0" :level=6>
            </BaseHeading>
        </button>
    </div>
    <div :id="'collapse' + index" class="collapse accordion-collapse p-0 m-0" :aria-labelledby="'heading' + index"
        data-bs-parent="#faqAccordion">
        <slot name="answer">
        </slot>
    </div>
    <hr>
</template>

<script lang="ts" setup>
import BaseHeading from '../base/BaseHeading.vue';

defineProps({
    title: {
        type: String,
        required: true
    },
    index: {
        type: Number
    }
});
</script>

<style lang="scss" scoped>
@import '@/styles/components/home/faqAccordion';
</style>
